module.exports = __webpack_public_path__ + "static/media/undraw_faq_rjoy.e1312399.svg";